module.exports = __webpack_public_path__ + "img/btn.83998338.png";